import { safeDefine } from '@breuni-ui/safe-define';
import { Carousel } from '@breuni-ui/carousel';

const numberOfSlidesProperty = '--num-slides';

const defaultNumberOfSlides = '3.5';

const numOfSlidesToChooseFrom = new Map([
  [0, '2.5'],
  [688, '3.5'],
  [1160, '4.5'],
  [1360, '5.5'],
  [1660, '6.5'],
  [1920, '7.5'],
]);

const ascending = (a, b) => a - b;

const getNumSlidesForCurrentWidth = (containerWidth, numOfSlides) => numOfSlides.get(
  [...numOfSlides.keys()]
    .sort(ascending)
    .reverse()
    .find(width => containerWidth >= width),
) || defaultNumberOfSlides;

export default class EntsCarousel extends Carousel {
  constructor(props) {
    super(props);

    this.resizeObserver = new ResizeObserver(() => {
      const numOfSlides = getNumSlidesForCurrentWidth(
        this.offsetWidth,
        numOfSlidesToChooseFrom,
      );
      this.style.setProperty(numberOfSlidesProperty, numOfSlides);
    });
  }

  connectedCallback() {
    super.connectedCallback();
    this.resizeObserver.observe(this);
    window.requestAnimationFrame(() => {
      const numOfSlides = getNumSlidesForCurrentWidth(
        this.offsetWidth,
        numOfSlidesToChooseFrom,
      );
      this.style.setProperty(numberOfSlidesProperty, numOfSlides);
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.resizeObserver.disconnect();
  }
}

safeDefine('ents-carousel', EntsCarousel);
